// CI$ → US$ conversion for display purposes only — server data (invoices,
// reports) stays CI$; this is purely how the admin UI presents it. `rate`
// is 1 CI$ = `rate` US$ (see redux/slices/systemSettingsSlice.js /
// SystemSettings.invoiceRates.usdToCiRate, official peg default 1.20).
export const ciToUsd = (ciAmount, rate) => (Number(ciAmount) || 0) * (Number(rate) || 1.2);

export const formatUsd = (amount) =>
  `$${(Number(amount) || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const formatCi = (amount) =>
  `CI$${(Number(amount) || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// "CI$100.00 (≈ $120.00)" — for admin-only views of an actual invoice
// amount, where the CI$ figure is the real billed number and the US$ is
// just a convenience conversion. Never used on the customer-facing
// invoice document itself — that stays CI$ only.
export const formatCiWithUsd = (ciAmount, rate) =>
  `${formatCi(ciAmount)} (≈ ${formatUsd(ciToUsd(ciAmount, rate))})`;
